import { Sku } from "../../../types";
import { i18n } from "../../i18n";
import { SellersItem } from "./SellersItem";
import { Pill } from "../Pill";
import { hideTooltip, toggleTooltip, Tooltip } from "../Tooltip";
import { selectAll } from "@fruugo/utilities";

export const SellersItemList = ({
  listItems,
  gaListId,
  gaListName,
}: {
  listItems: Sku[];
  gaListId: string;
  gaListName: string;
}) => {
  return (
    <ul class="tw:p-4 tw:m-0 tw:list-none tw:flex tw:flex-col tw:gap-5 tw:overflow-y-auto">
      <div
        class="tw:relative tw:inline-block tw:m-auto tw:z-20 tw:cursor-pointer"
        onClick={() => toggleTooltip(".ordered-by-tooltip")}
        onBlur={() => hideTooltip(".ordered-by-tooltip")}
        tabIndex={0}
      >
        <Pill
          text={
            <span>
              <strong>{i18n("product.ordered-by")}</strong>{" "}
              {i18n("product.ordered-by.lowest-price")}
            </span>
          }
        />
        <Tooltip
          id={"ordered-by-tooltip"}
          text={i18n("product.ordered-by.lowest-price.tooltip")}
        />
      </div>

      {listItems.map((item) => (
        <SellersItem item={item} gaListId={gaListId} gaListName={gaListName} />
      ))}
    </ul>
  );
};

export function fadeInItems() {
  const items = selectAll<HTMLLIElement>("li[data-reveal]:not(.is-visible)");

  items.forEach((item, index) => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        item.classList.add("is-visible", "tw:opacity-100", "tw:translate-y-0");
        item.classList.remove("tw:opacity-0", "tw:translate-y-3");
      }, index * 200);
    });
  });
}
